import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";
const getSortLocationPlanEndPoint = '/sls/get-sort-plan';
const spgProcessName = "sortPathGenerator";

/**
 * Gets a presigned S3 URL containing package-level OV planned sortZone info in CSV format
 * @param {string} nodeId - The station code
 * @param {string} cycleId - The cycle ID
 * @param {string} fileType - The file type (e.g., 'csv')
 * @returns {Promise<string>} - Presigned URL for downloading the sort plan CSV
 */
export async function GetSortPlanResource(nodeId, cycleId, fileType) {
    const requestBody = {
        stationCode: nodeId,
        cycleName: cycleId,
        fileType: fileType
    };

    const request = getAPIGatewayPostRequest(getSortLocationPlanEndPoint, requestBody);
    const response = await getAPIGatewayDataFromParent(request);

    return response;
}

function getAPIGatewayPostRequest(endpoint, request, httpMethod = "POST") {
    return {
        resourcePath: endpoint,
        httpMethod: httpMethod,
        processName: spgProcessName,
        requestBody: request
    }
}


// WEBPACK FOOTER //
// ./src/resources/GetSortPlanResource.js